define('SuiteCommerce.OrderStatus.Instrumentation.Logger', [
	'SuiteCommerce.OrderStatus.Instrumentation.FallbackLogger',
	'SuiteCommerce.OrderStatus.Instrumentation.MockAppender',
], function define(InstrumentationFallbackLogger, InstrumentationMockAppender) {
	'use strict';
	var environment = null;
	var instance = null;
	var QUEUE_NAME_SUFFIX = '-OrderStatus';
	return {
		initialize: function initialize(localEnvironment) {
			environment = localEnvironment;
		},
		getLogger: function getLogger() {
			instance = instance || this.buildLoggerInstance();
			return instance;
		},
		buildLoggerInstance: function buildLoggerInstance() {
			var logConfig = {};
			try {
				var LoggersModule = require('Loggers').Loggers;
				var elasticAppender =
					require('Loggers.Appender.ElasticLogger').LoggersAppenderElasticLogger.getInstance();
				var mockAppender = InstrumentationMockAppender.getInstance();
				var configurationModule = require('Loggers.Configuration');
				var loggerName = 'CommerceExtensions' + QUEUE_NAME_SUFFIX;
				logConfig[loggerName] = {
					log: [
						{ profile: configurationModule.prod, appenders: [elasticAppender] },
						{ profile: configurationModule.dev, appenders: [mockAppender] },
					],
					actions: {},
					loggers: {},
				};
				LoggersModule.setConfiguration(logConfig);
				return LoggersModule.getLogger(loggerName);
			} catch (e) {
				return InstrumentationFallbackLogger.getLogger(environment);
			}
		},
	};
});
